import { LeasePeriodKind, NoticePeiodTimeUnitKind, TerminatedByKind } from './const/enums';
import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';

export class NoticePeriod extends ModelBase {
  constructor() {
    super();
    this.from = LocalDate.fromDate(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1));
    this._prolongationTime = 12;

    Object.defineProperties(this, {
      _fromDate: { writable: true, enumerable: false },
      _lastDebit: { writable: true, enumerable: false },
      _toDate: { writable: true, enumerable: false },
      _terminationDate: { writable: true, enumerable: false },
      _desiredMoveOutDate: { writable: true, enumerable: false },
    });
  }

  private _prolongationTime: number;

  private _fromDate: LocalDate;
  private _lastDebit: LocalDate;
  private _toDate: LocalDate;
  private _terminationDate: LocalDate;
  private _desiredMoveOutDate: LocalDate;

  get from(): LocalDate {
    return this._fromDate;
  }
  set from(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }
  get lastDebit(): LocalDate {
    return this._lastDebit;
  }
  set lastDebit(value: LocalDate) {
    this._lastDebit = LocalDate.fromDate(value);
  }
  get desiredMoveOutDate(): LocalDate {
    return this._desiredMoveOutDate;
  }
  set desiredMoveOutDate(value: LocalDate) {
    this._desiredMoveOutDate = LocalDate.fromDate(value);
  }
  get terminationDate(): LocalDate {
    return this._terminationDate;
  }
  set terminationDate(value: LocalDate) {
    this._terminationDate = LocalDate.fromDate(value);
  }
  landlordDuration: number = 3;
  landlordTimeUnit: NoticePeiodTimeUnitKind = NoticePeiodTimeUnitKind.Month;
  leasePeriod: LeasePeriodKind = LeasePeriodKind.UntilFurtherNotice;
  allowEarlyTermination: boolean;
  terminatedBy: TerminatedByKind = TerminatedByKind.Tenant;

  get prolongationTime(): number {
    return this._prolongationTime;
  }
  set prolongationTime(value: number) {
    if (value === 0) return;
    this._prolongationTime = value;
  }
  tenantDuration: number = 3;
  tenantTimeUnit: NoticePeiodTimeUnitKind = NoticePeiodTimeUnitKind.Month;
  get to(): LocalDate {
    return this._toDate;
  }
  set to(value: LocalDate) {
    this._toDate = LocalDate.fromDate(value);
  }

  toJSON() {
    const json = Object.assign({}, this);
    json.from = this.from;
    json.lastDebit = this.lastDebit;
    json.terminationDate = this.terminationDate;
    json.desiredMoveOutDate = this.desiredMoveOutDate;
    json.to = this.to;
    return json;
  }
}
